import type { NimbleAtsJobId } from "@nimble/datamodel/types/nimbleAtsJobId";
import type { UserId } from "@nimble/datamodel/types/userId";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createApplication } from "@/lib/api-clients/candidate-api-client";

type CreateApplicationVariables = {
  userId: UserId;
  jobId: NimbleAtsJobId;
};

export default function useCreateApplicationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, jobId }: CreateApplicationVariables) =>
      createApplication(userId, jobId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["applications"] });
    },
  });
}
